// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_c1-b";
export var colorBlue = "_c1-8";
export var colorDot = "_c1-0";
export var colorDotLarge = "_c1-2";
export var colorDotSmall = "_c1-1";
export var colorGreen = "_c1-7";
export var colorGrey = "_c1-3";
export var colorOrange = "_c1-5";
export var colorPink = "_c1-a";
export var colorPurple = "_c1-9";
export var colorRed = "_c1-4";
export var colorYellow = "_c1-6";